module.exports = __webpack_public_path__ + "img/feed-back-icon.9de26073.png";